<template>
  <div style="padding-top:88px;">
    <div class="dci-top">
      <div style="text-align:center;margin:40px 0 54px;">
          <p class="p-46">关于DCI</p>
          <img src="./images/dci.png" class="dciFlag" />
      </div>
      <ul class="dci-top-ul">
        <li v-for="(item,index) in ulList" :key="index">         
          <div class="p-18"><span class="round"></span>{{item.title}}</div>
          <div class='p-14'>{{item.content}}</div>
        </li>
      </ul>
    </div>
    <div class="dci-step">
      <div class="dci-step-content">
        <div style="text-align:center;margin:85px 0 41px;">
          <p class="p-46">作品登记证书申请服务流程</p>
          <img src="./images/process.png" class="dciFlagTwo" />
        </div>
        <div class="dci-step-box">
          <div class="dci-step-flex">
            <img src="./images/1.png" class="step-icon" />
            <p class="p-16">选择作品</p>
            <p class="p14">从已经获得版权存证</p>
            <p class="p14">证书的作品中选择适宜作品</p>
          </div>
          <div><img src="./images/path.png" class="step-path" /></div>
          <div class="dci-step-flex">
            <img src="./images/2.png" class="step-icon" />
            <p class="p-16">完善信息</p>
            <p class="p14">完善申请作品登记证书</p>
            <p class="p14">所需的创作意图、作品独创性等信息</p>
          </div>
          <div><img src="./images/path.png" class="step-path" /></div>
          <div class="dci-step-flex">
            <img src="./images/3.png" class="step-icon" />
            <p class="p-16">信息审核</p>
            <p class="p14">经版权局</p>
            <p class="p14">7-10个工作日审核</p>
          </div>
          <div><img src="./images/path.png" class="step-path" /></div>
          <div class="dci-step-flex">
            <img src="./images/4.png" class="step-icon" />
            <p class="p-16">颁发证书</p>
            <p class="p14">审核通过后将获得国家</p>
            <p class="p14">版权局颁发的作品登记证书（电子版）</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "groupDci", 
  data(){
    return{            
     ulList:[
       {title:'什么是DCI体系',content:'DCI体系是中国版权保护中心提出的以“数字版权唯一标识符”（Digital Copyright Identifier，简称DCI）为基础的数字版权公共服务新模式。'},
       {title:'DCI体系的业务',content:'DCI体系具有三大基本功能：数字作品版权登记、版权费用结算认证、监测取证快速维权。综合支撑建立起包括版权确权、授权、维权在内的全流程版权综合服务体系。'},
       {title:'DCI体系的价值',content:'DCI体系是中国版权保护中心提出的以“数字版权唯一标识符”（Digital Copyright Identifier，简称DCI）为基础的数字版权公共服务新模式。'}
     ]
    }
  },
  methods:{
  
  }
       
};
</script>

<style scoped lang="less">
.dci-top{
  width:1334px;
  height:560px;
  background:rgba(255,255,255,1);
  margin:0 auto;
  overflow: hidden;
  .dciFlag{
    width:111px;
    height: 54px;
    position: relative;
    top:-37px;
  }
  .dci-top-ul{
    overflow: hidden;
    li{
      list-style: none;
      .round{
        display: inline-block;
        width:10px;
        height:10px;
        background:rgba(18,18,16,1);
        border-radius: 100%;
        margin-right: 16px;
      }
      .p-18{
        font-size:18px;
        font-weight:400;
        color:rgba(18,16,0,1);
        letter-spacing:1px;
        margin-bottom: 8px;
      }
      .p-14{
        font-size:14px;
        font-weight:400;
        color:rgba(18,16,0,1);
        margin-left: 26px;
        margin-bottom: 36px;
      }
    }
  }
}
.p-46{
  font-size:46px;
  font-weight:500;
  color:rgba(24,24,24,1);
  letter-spacing:2px;
}
.dci-step{
  width:100%;
  height:539px;
  background:rgba(248,248,248,1);
  .dciFlagTwo{
    width:246px;
    height: 53px;
    position: relative;
    top:-37px;
  }
  .dci-step-content{
    width:1334px;
    height:539px;
    margin: 0 auto;
    overflow: hidden;
    .dci-step-box{
      display: flex;
      justify-content: flex-start;
      .dci-step-flex{
        width:260px;
        text-align: center;
        .step-icon{
          width:102px;
          height: 102px;
        }
        .p-16{
          font-size:16px;
          font-weight:500;
          color:rgba(18,18,16,1);
          margin:13px 0 11px;
        }
        .p14{
          font-size:14px;
          font-weight:400;
          color:rgba(18,16,0,1);
          line-height:24px;
        }        
      }
      .step-path{
        width:54px;
        height: 36px;
        margin-top: 31px;
      }
    }
  }
}
</style>
